import { useEffect, useState } from "react";
import { MOBILE_BREAKPOINT } from "../utils/deviceInfo";

const isNarrowScreen = () => window.innerWidth < MOBILE_BREAKPOINT;

const useIsNarrowScreen = () => {
  const [isNarrow, setIsNarrow] = useState(isNarrowScreen);

  useEffect(() => {
    const handleResize = () => setIsNarrow(isNarrowScreen());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isNarrow;
};

export default useIsNarrowScreen;
